import React from "react";
import { Helmet } from "react-helmet";

const ReturnandRefundPolicy = () => {
  return (
    <>
    <Helmet>
        <title>Return and Refund Policy – Webs2PDF</title>
        <meta
          name="title"
          content="Return and Refund Policy – Webs2PDF"
        />
        <meta
          name="description"
          content="Review our refund and return policy to understand how we handle subscription cancellations and refund requests for Webs2PDF services."
        />
        <link rel="canonical" href="https://webs2pdf.com/return-and-refund-policy" />
      </Helmet>
      <div className="hero-section-wrap policy-wrap">
        <div className="container">
          <h1>Return and Refund Policy</h1>
          <p><b>Effective Date::</b> June 20, 2025</p>
          <h3>Instant Conversions – Final Sale</h3>
          <p>
            For one‐time conversions, the transaction is complete once the PDF
            is generated and available for download. No refunds, credits, or
            exchanges will be issued for:
            <ul>
              <li>Formatting/layout discrepancies</li>
              <li>Incorrect or inaccessible URLs supplied by the user</li>
              <li>Expectations regarding look‐and‐feel of the PDF output</li>
            </ul>
          </p>

          <h3>Subscription Plans – Cancellation & Refunds</h3>
          <ul>
            <li>
              <strong>Cancellation:</strong> You may cancel at any time; your
              plan remains active until the current billing cycle ends. No
              partial or prorated refunds for unused time.
            </li>
            <li>
              <strong>Refund Eligibility:</strong> Refunds may be granted only
              if (a) a verified technical failure renders the Service unusable
              and we cannot remedy the issue, or (b) an accidental subscription
              is reported within 14 days and no conversions have been consumed.
            </li>
            <li>
              <strong>Request Procedure:</strong> Email{" "}
              <a href="mailto:info@webs2pdf.com">
                <b>info@webs2pdf.com</b>
              </a>{" "}
              with account email, plan, transaction ID, and description of the
              issue. We review all requests within five business days.
            </li>
          </ul>

          <h3>Duplicate Charges & Conversion Failures (One‐Time)</h3>
          <p>
            If you are charged twice for the same conversion or the system fails
            to generate/download a PDF due to our error, contact us within <b>3
            calendar days </b> with proof (URL, timestamp, receipt, error details).
            Valid claims will be refunded to the original payment method within
            five business days.
          </p>

          <h3>Dispute Resolution</h3>
          <p>
            Contact us before initiating any chargeback or payment dispute. We
            aim to resolve eligible issues promptly and fairly.
          </p>

          <h3>Acknowledgement</h3>
          <p>
            By using Webs2PDF.com (instant or subscription), you agree to abide
            by this Return & Refund Policy and acknowledge that digital
            deliveries are non‐reversible except as explicitly stated above.
          </p>
        </div>
      </div>
    </>
  );
};

export default ReturnandRefundPolicy;
